import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";
import { useSelector } from "react-redux";
import moment from "moment";
import { Spin } from "antd";
import Chart from "react-google-charts";
import { chartColors } from "../../reports/colors";

const DiamondReportsPriceComp = ({
  globalDiamonds,
  isApplyFilter,
  mainForDealer,
}) => {
  const { t } = useTranslation();
  /*React Binding Starts*/
  const loginDetials = useSelector((state) => state.loginReducer);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [diamondPriceLabels, setdiamondPriceLabels] = useState([]);
  const [DiamondPriceYAxisList, setDiamondPriceYAxisList] = useState([]);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [TooltipPercentage, setTooltipPercentage] = useState("");
  const [IsReportEmpty, setIsReportEmpty] = useState(true);
  const [key, setKey] = useState(true);

  // New states for processed chart data
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum entries to show
  /*React Binding Ends*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          handleLoadExtendedDiamondChartReports(
            loginDetials.loginDetials.responseData.dealerId,
            mainForDealer
          );
        }
      }
    }
  }, [isApplyFilter]);

  // Process chart data with max entries limit
  const processChartData = (priceList) => {
    if (!priceList?.length) {
      return { chartData: [], colors: [] };
    }

    // Filter out zero values and sort by total (descending)
    const filteredData = priceList.filter((item) => item.TOTAL > 0);
    const sortedData = [...filteredData].sort((a, b) => b.TOTAL - a.TOTAL);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce(
      (sum, item) => sum + item.TOTAL,
      0
    );
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        Range: t("Others"),
        TOTAL: othersValue,
        isOthers: true,
      });
    }

    // Calculate total for percentages
    const total = topData.reduce((sum, item) => sum + item.TOTAL, 0);

    // Prepare chart data
    const processedChartData = [["Price Range", "Count"]];
    const colors = [];

    topData.forEach((item, index) => {
      const percentage =
        total > 0 ? ((item.TOTAL / total) * 100).toFixed(1) : 0;
      const color = item.isOthers
        ? "#CCCCCC"
        : chartColors[index % chartColors.length];
      colors.push(color);

      processedChartData.push([`${item.Range} (${percentage}%)`, item.TOTAL]);
    });

    return { chartData: processedChartData, colors };
  };

  /*API Binding Starts*/
  const handleLoadExtendedDiamondChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        reportName: "ExtDiamondChrt",
      };
      setLoadChartReportsLoading(true);

      ReportsDiamondService.LoadExtendedDiamondChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondPriceList = responseData.DiamondPrice;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              if (
                responseData.DiamondPrice.every((item) => {
                  return item.TOTAL == 0;
                })
              ) {
                setIsReportEmpty(true);
              } else {
                setIsReportEmpty(false);
              }
              var DiamondPriceLabelArr = DiamondPriceList.map((item) => {
                return item.Range;
              });
              setdiamondPriceLabels(DiamondPriceLabelArr);
              var DiamondPriceYAxisList = DiamondPriceList.map((item) => {
                return item.TOTAL;
              });
              setDiamondPriceYAxisList(DiamondPriceYAxisList);
              var totalValueForPercentage = DiamondPriceYAxisList.reduce(
                (a, b) => a + b,
                0
              );
              setTotalValueForPercentage(totalValueForPercentage);

              // Process data with max entries limit
              const { chartData: processedData, colors } =
                processChartData(DiamondPriceList);
              setChartData(processedData);
              setColorData(colors);

              setKey(!key);
            }
          } else {
            setDiamondPriceYAxisList([]);
            setChartData([]);
            setColorData([]);
            setIsReportEmpty(true);
          }
        })
        .catch((error) => {
          setDiamondPriceYAxisList([]);
          setChartData([]);
          setColorData([]);
          setLoadChartReportsLoading(false);
          setdiamondPriceLabels([]);
          setIsReportEmpty(true);
        });
    } catch (error) {
      setDiamondPriceYAxisList([]);
      setChartData([]);
      setColorData([]);
      setLoadChartReportsLoading(false);
      setdiamondPriceLabels([]);
      setIsReportEmpty(true);
    }
  };
  /*API Binding Ends*/

  const pieChartOptions = {
    is3D: true,
    legend: {
      position: "none",
    },
    chartArea: {
      width: "100%",
      height: "100%",
      left: window.innerWidth > 500 ? 50 : 10,
      top: 50,
      bottom: 50,
    },
    tooltip: {
      trigger: "focus",
      text: "both",
      textStyle: {
        fontSize: 14,
      },
    },
    pieSliceText: "percentage",
    colors: colorData,
    sliceVisibilityThreshold: 0.01, // Show label even for small slices
  };

  // Custom Legend Component
  const CustomLegend = () => {
    if (!chartData.length || chartData.length <= 1) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        {chartData.slice(1).map((row, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              margin: "4px 8px",
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                width: "14px",
                height: "14px",
                backgroundColor: colorData[index],
                marginRight: "6px",
                borderRadius: "3px",
              }}
            ></div>
            {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
          </div>
        ))}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="col-lg-12 mt-4">
        <label>
          <b> {t("Diamond Price")} </b>
        </label>
        <div
          className="chart__section"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Spin spinning={LoadChartReportsLoading} size="large">
            {!IsReportEmpty && chartData.length > 1 ? (
              <>
                {/* Custom Legend */}
                <CustomLegend />

                {/* Centered Pie Chart */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Chart
                    key={key}
                    chartType="PieChart"
                    width={window.innerWidth > 500 ? 800 : 320}
                    height={window.innerWidth > 500 ? 500 : 320}
                    data={chartData}
                    options={pieChartOptions}
                  />
                </div>
              </>
            ) : (
              <div className="no-report-render">
                <div className="desc-space">
                  <h4 className="text-center">{t("No Data Found")}</h4>
                </div>
              </div>
            )}
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsPriceComp;
